// If you want to use variables, they should not include white spaces inside like `{{var}}`
export default {
  common: {
    next: "NEXT",
    back: "BACK",
    close: "CLOSE",
    cancel: "CANCEL",
    submit: "SUBMIT",
    hide: "HIDE",
    show: "SHOW",
    publish: "SHOW PRODUCT",
    unpublish: "HIDE PRODUCT",
    done: "DONE",
    ok: "OK",
    leave: "LEAVE",
    price: "PRICE",
    duration: "DURATION",
    stay: "STAY",
    product: "PRODUCT",
    yes: "YES",
    no: "NO",
    download: "Download",
    uploadError: "Please ensure the file is less than 10MB",
    errorMessage: "Sorry something went wrong! Please try again later or contact Admin!",
  },
  month: {
    January: "January",
    February: "February",
    March: "March",
    April: "April",
    May: "May",
    June: "June",
    July: "July",
    August: "August",
    September: "September",
    October: "October",
    November: "November",
    December: "December",
  },
  label: {
    productName: "Product Name",
    tradeTerm: "Trade Term",
    port: "Port",
    packaging: "Packaging",
    shipmentMonth: "Shipment Month",
    currency: "Currency",
    unit: "Unit",
  },
  marketProviders: {
    sourcesageTitle: "Oils, Oleo & Surfactants Pricing",
    sourcesageSubtitle: "Oils & Fats, Oleochemicals, Surfactants",
    sourcesageBody: "Palm Oil, PKO, Fatty Alcohol Fatty Acids, SLES, SLS...",
    emptyStateTitle: "New Feature Coming Soon!",
    emptyStateBody: "Select different market providers to view their reported prices.",
    othersTitle: "Other Providers",
    othersSubtitle: "Oils & Fats, Oleochemicals, Surfactants",
    othersBody: "Edible Oils & Fats, Oleochemicals, Surfactants, Petrochemicals",
  },
  DataSearchPage: {
    banner: "https://s3-ap-southeast-1.amazonaws.com/sourcesage/images/data-upload/Banner.png",
    mine: "Your Data Page",
    public: "Select market provider",
    private: "Private View Only",
    private_note: "(You are invited to view the price list below)",
    placeholder: "Type Product Name to Check daily prices",
  },
  setPrice: {
    title: "Set Price",
    sub: "Please set the duration & price for One Visit",
    text: "Earn by charging your customer per each visit to your data page!",
    sub2: "Please set no. of visits for Free trials",
    text2: "You can attract new customers with free visits to your data page!",
    credit: "USD", 
    hours: "Hours",
    visit: "VISIT",
    warn: "*When you edit your time period /prices, it will only applied for the next cycle for your current users",
    free: "No, I want to share my data for FREE",
  },
  dataPageStepsModal: {
    title: "Step", // followed by 1, 2 or 3
    sub1: "List your products",
    text1: "Update your products, and other details before publishing on a page for your customers",
    sub2: "Update prices of your products",
    text2: "Provide your customers the most recent prices by updating on the go",
    sub3: "Earn money from each visit",
    text3: "You can choose to charge each customer for each visit on SourceSage, and cash out the money from SourceSage platform",
  },
  dataList: {
    submit: "Update Changes",
    subHeader: "Price Reporting | Last updated",
    tableHeader1: "PRODUCT & INFO",
    tableHeader2: "PRICE",
    addProduct: "ADD PRODUCT",
    successModalHeader: "Your Prices Are Updated",
    errorModalHeader: "You can not update data prices",
    delivery: "Delivery",
    spotPrice: "Spot Price",
    preview: "Preview",
    previewError: "You can not see preview",
    last_update: "Last update: {{date}}",
    public_view: "Public View",
    private_view: "Private View Only",
    follower: "Follower",
    followers: "Followers",
    attachment: "ATTACHMENT",
    attach_last_update: "LAST UPDATE",
    action: "ACTION",
    remove: "REMOVE",
    rename: "RENAME",
    save: "SAVE",
    add_attachment: "ADD ATTACHMENTS +",
    update_attachment: "UPDATE ATTACHMENTS",
    max_files: "Maximum 3 pdf(s)",
    current_price: "Current Price"
  },
  dataEntry: {
    last_update: "LAST UPDATED ON {{date}}",
    preview: "LIVE PREVIEW",
    update: "UPDATE DATA PAGE",
    use_credit: "Pay now",
    free: "Free Access",
    free_trial: "Use Free Trial",
    warn: "The channel has updated their terms since your last access, please note the new price/duration",
    purchase: "Purchase Credit",
    insufficient_title: "Insufficient Credit",
    insufficient_text: "You don't have enough credits to enter this page. Please purchase credits.",
    payAccess: "Pay {{credit}} USD for {{hour}} hours access",
    payAccessManager: "Your users will pay {{credit}} USD for {{hour}} hours access",
    freeAccess: "You are entitled to {{access}} time(s) free trial",
  },
  dataView: {
    product: "PRODUCT AND INFO",
    price: "PRICE",
    change: "CHANGE",
    preview: {
      pre_public: "Public View.",
      pre_private: "Private View Only.",
      public: "This page will be shown to public audience.",
      private: "This page will only be shown to invited users",
      exit: "Exit Preview",
      price_report: "Price report | Last updated {{date}}",
    },
  },
  dataItem: {
    note: "*Please fill up the compulsory fields. Note that these information is not editable in future",
    leave: "Do you want to leave this page? Your changes will be unsaved. Please click Done on the Top Right Corner",
    price: "Price",
    spot: "Spot Price (Delivery is normally within next 30 days)",
    future: "Future Price (Delivery is not within next 30 days)",
    price_type: "Price Type",
    price_single: "Single Price",
    price_range: "Price Range",
    price_max: "Max Price",
    price_min: "Min Price",
    confirmDialog: {
      title: "Are you sure to make changes?",
      next: "SAVE CHANGES",
      visit_fee: "Cost per Access:",
      visit_fee_text: "{{credit}} USD per {{hours}} hours",
      free_trial: "Number of Free Trials for first time user:",
      free_trial_text: "{{visits}} visits",
      set_price: "Edit Cost per Access",
    },
    placeholder: {
      productName: "Palm Oil, C1214",
      price: "Enter price here",
      port: "eg. Jakarta, Klang, etc.",
      shipMonth: "Select Shipment Month",
    },
  },
  shopUpload: {
    ProductStep1: "Step 01: Product Details",
    SeriesStep1: "Step 01: Series Details",
    SeriesStep2: "Step 02: Series Display",
    ProductStep2: "Step 02: Product Display",
    AddDisplayPic: "Add Display Picture",
    SeriesReady: "Your Series is Ready !",
    ProductReady: "Your Product is Ready !",
    SeriesReadyInfoText: "Now users can subscribe to your series. You can also tag your product into this series when uploading your data",
    ProductReadyInfoText: 'Your product is published ! You can still edit the report description on product dialogue ! You can track the sales on "View Sales"',
    ProductPopupTitle: "Now you can offer a subscription based series!",
    ProductPopupBody: "Upload multiple report periodically for your customers in a series or package. You can define its frequency and price for user to subscribe.",
    UploadProductText: "Upload your product in pdf format",
    UploadProductSizeLimit: "Max Size 10MB",
    UploadImage: "UPLOAD IMAGE",
    UploadNewProduct: "UPLOAD NEW PRODUCT",
    UploadProduct: "UPLOAD PRODUCT",
    UploadPreview: "UPLOAD PREVIEW",
    AddExistingProduct: "ADD EXISTING PRODUCTS",
    name: "Name of Product/Service",
    description: "Description",
    tag: "Product Tag",
    AddToSeries: "Add to Subscription Series (optional)",
    isThisforSale: "Is this item for sale ?",
    forSale: "For Sale",
    notForSale: "Free",
    frequency: "Frequency",
    price: "Price (USD)",
    PreviewQn: "Do you have a preview file?",
    EditSeries: "EDIT SERIES",
    EditProduct: "EDIT PRODUCT",
    SaveSeries: "SAVE SERIES",
    DeleteSeries: "DELETE SERIES",
    SelectProducts: "Select existing product(s) into ",
    SelectedItems: "item(s) are selected",
    YourProduct: "Your Product *",
    DeleteConfirmSeries: "Are you sure you want to delete this series?",
    DeleteConfirmProduct: "Are you sure you want to delete this product?",
    DeleteSuccessSeries: "You have successfully deleted your series!",
    DeleteSuccessProduct: "You have successfully deleted your product!",
    EditSuccess: "You have successfully saved your series!",
    AddProductSuccess: "You have successfully added products!",
    RemoveProduct: "Remove",
    RemoveProductConfirm: "Are you sure you want to delete this product ?",
    SeePreview: "See Preview",
    EditPage: "Edit Page",
    all: "All",
    Leave: "Do you want to leave this page? Your changes will be unsaved",
    PricePerYear: "Price per year",
    CannotUndo: "This cannot be undo",
    ChangeImage: "CHANGE IMAGE",
    SaveProduct: "SAVE PRODUCT",
    Replace: "REPLACE",
    DeleteProduct: "DELETE PRODUCT",
    BuyProduct: " Buy for {{credit}} USD",
    PurchaseSuccess: "You have purchased this item. A confirmation email will be sent to you shortly.",
    InsufficientPurchase: "You do not have enough credits to purchase this item. Your remaining balance is {{current_balance}}",
    NoCreditCard: "To continue, please purchase credits to exchange for products and services on the platform.",
    AddPaymentMethod: "Add Payment Method",
    PurchaseCredits: "Purchase Credits",
    Credits: "USD",
    ForSubscription: "{{price}} USD per year (for {{frequency}} Subscription Only)",
    YourProductFile: "Your Product:",
    YourPreviewFile: "Your Preview:",
    Price: "Price in USD",
    Free: "Free",
    Subscribe: "Subscribe",
    Subscribed: "Subscribed",
    frequencyOptions: {
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly",
      quarterly: "Quarterly",
      yearly: "Yearly",
    },
  },
  profile: {
    dataPrice: {
      data: "Data",
      title: "Set up your own Pricing Page",
      sub: "Want your prices on the Pricing Page? You can list the prices of your products, update on the go, and notify your customers!",
      set_up_now: "SET UP NOW",
    },
  },
  trade: {
    trade_term: {
      CFR: "CFR",
      CIF: "CIF",
      CIP: "CIP",
      CPT: "CPT",
      DAP: "DAP",
      DAF: "DAF",
      DEQ: "DEQ",
      DES: "DES",
      DDP: "DDP",
      DDU: "DDU",
      Exworks: "Exworks",
      FAS: "FAS",
      FCA: "FCA",
      FOB: "FOB",
    },
    packaging_type: {
      Drums: "Drums",
      Bags: "Bags",
      Flexibags: "Flexibags",
      "Bulk Vessel": "Bulk Vessel",
      IBC: "IBC",
      Isotank: "Isotank",
      Carton: "Carton",
      "Pallet": "Pallet",
      "Tanker": "Tanker"
    },
    price_currency: {
      EUR: "EUR",
      GBP: "GBP",
      RMB: "RMB",
      SGD: "SGD",
      USD: "USD",
      MYR: "MYR",
      INR: "INR"
    },
    unit: {
      MT: "MT",
      lb: "lb",
      gal: "gal",
      "troy ounce": "troy ounce",
      bbl: "bbl",
      kg: "kg",
      l: "l",
      ml: "ml",
      FCL: "FCL",
      carton: "carton",
    },
  },
  user: {
    name: "Name",
    company_name: "Company Name",
  },
  channelsList: {
    tags: "Tag",
    search: "Search a keyword/channel",
    allChannels: "ALL\nCHANNELS",
    noChannelFound: "Sorry, currently there is no channel found",
    noSearchResult: "NO SEARCH RESULTS?",
    noSearchResultDescription: "Click on above to let our customer service, Amanda, knows what information you are looking for!",
    loadingData: "Please wait for data to load...",
    open: "Open",
    loadMore: "Load More",
  },
  email: {
    subscribe: "Subscribe",
    lead_text: "Subscribe for news from {{channelName}}'s updates, products and services!",
    input_placeholder: "Enter your email here",
    error_invalid_email: "That email is invalid.",
    error_already_subscribed: "That email has already subscribed.",
    success_subscribed: "You have joined the mailing list of {{channelName}}.",
    item_email_success: "The link to download the item has been sent to your email.",
    header: "Free Download",
    body: 'We will send "{{productName}}" to your email below',
  },
};



// WEBPACK FOOTER //
// ./app/constants/translations/react-native/en.ts